import type { SVGProps } from "react";

export default function NoClientsGroupIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="36" cy="18" r="11" fill="#F5A801" />
      <ellipse cx="36" cy="51" rx="17" ry="11" fill="#F5A801" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36 3.75C28.13 3.75 21.75 10.13 21.75 18C21.75 25.8701 28.13 32.25 36 32.25C43.8702 32.25 50.25 25.8701 50.25 18C50.25 10.13 43.8702 3.75 36 3.75ZM26.25 18C26.25 12.6152 30.6153 8.25 36 8.25C41.3847 8.25 45.75 12.6152 45.75 18C45.75 23.3848 41.3847 27.75 36 27.75C30.6153 27.75 26.25 23.3848 26.25 18Z"
        fill="#F4F4F4"
      />
      <path
        d="M54 10.167C59.6607 10.167 64.833 14.0506 64.833 19.5C64.833 24.9494 59.6607 28.833 54 28.833C52.9875 28.833 52.167 28.0125 52.167 27C52.167 25.9875 52.9875 25.167 54 25.167C58.2937 25.167 61.167 22.3238 61.167 19.5C61.167 16.6762 58.2937 13.833 54 13.833C52.9875 13.833 52.167 13.0125 52.167 12C52.167 10.9875 52.9875 10.167 54 10.167Z"
        fill="#F4F4F4"
        stroke="#F4F4F4"
        strokeWidth="0.833333"
      />
      <path
        d="M20.25 12C20.25 10.7574 19.2426 9.75 18 9.75C12.1883 9.75 6.75 13.7485 6.75 19.5C6.75 25.2514 12.1883 29.25 18 29.25C19.2426 29.25 20.25 28.2426 20.25 27C20.25 25.7574 19.2426 24.75 18 24.75C13.8705 24.75 11.25 22.0328 11.25 19.5C11.25 16.9672 13.8705 14.25 18 14.25C19.2426 14.25 20.25 13.2426 20.25 12Z"
        fill="#F4F4F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36 36.75C30.6471 36.75 25.6993 38.1924 22.024 40.6425C18.3644 43.0824 15.75 46.6998 15.75 51C15.75 55.3002 18.3644 58.9176 22.024 61.3575C25.6993 63.8076 30.6471 65.25 36 65.25C41.3529 65.25 46.3005 63.8076 49.9761 61.3575C53.6355 58.9176 56.25 55.3002 56.25 51C56.25 46.6998 53.6355 43.0824 49.9761 40.6425C46.3005 38.1924 41.3529 36.75 36 36.75ZM20.25 51C20.25 48.6726 21.6651 46.2903 24.5201 44.3868C27.3595 42.4938 31.4118 41.25 36 41.25C40.5882 41.25 44.6406 42.4938 47.4798 44.3868C50.3349 46.2903 51.75 48.6726 51.75 51C51.75 53.3274 50.3349 55.7097 47.4798 57.6132C44.6406 59.5062 40.5882 60.75 36 60.75C31.4118 60.75 27.3595 59.5062 24.5201 57.6132C21.6651 55.7097 20.25 53.3274 20.25 51Z"
        fill="#F4F4F4"
      />
      <path
        d="M57.8017 41.5174C58.0678 40.3036 59.2678 39.5356 60.4816 39.8017C63.367 40.4344 65.9674 41.5774 67.8979 43.1572C69.8269 44.7355 71.2495 46.9051 71.2495 49.4995C71.2495 52.0939 69.8269 54.2635 67.8979 55.8418C65.9674 57.4216 63.367 58.5646 60.4816 59.1973C59.2678 59.4634 58.0678 58.6954 57.8017 57.4816C57.5356 56.2678 58.3036 55.0678 59.5174 54.8017C61.8946 54.2803 63.7942 53.3851 65.0482 52.3591C66.3037 51.3319 66.7495 50.3284 66.7495 49.4995C66.7495 48.6706 66.3037 47.6671 65.0482 46.6399C63.7942 45.6139 61.8946 44.7187 59.5174 44.1973C58.3036 43.9312 57.5356 42.7312 57.8017 41.5174Z"
        fill="#F4F4F4"
      />
      <path
        d="M11.518 39.8017C12.7318 39.5356 13.9316 40.3036 14.1978 41.5174C14.464 42.7312 13.6957 43.9312 12.4819 44.1973C10.1049 44.7187 8.20515 45.6139 6.95136 46.6399C5.69589 47.6671 5.25 48.6706 5.25 49.4995C5.25 50.3284 5.69589 51.3319 6.95136 52.3591C8.20515 53.3851 10.1049 54.2803 12.4819 54.8017C13.6957 55.0678 14.464 56.2678 14.1978 57.4816C13.9316 58.6954 12.7318 59.4634 11.518 59.1973C8.63238 58.5646 6.0321 57.4216 4.10157 55.8418C2.17274 54.2635 0.75 52.0939 0.75 49.4995C0.75 46.9051 2.17274 44.7355 4.10157 43.1572C6.0321 41.5774 8.63238 40.4344 11.518 39.8017Z"
        fill="#F4F4F4"
      />
    </svg>
  );
}
